import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a028958f6558f001470a2ec/detailbook/src/app/not-found.tsx");
